import { ReactComponent as MyFinIcon } from "../assets/icons/myfin.svg";

export default function Home() {
  return (
    <>
      <center>
        <MyFinIcon width={200} style={{height:"100vh",opacity:0.2}} />
      </center>
    </>
  );
}
